var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReturnTop = function SvgReturnTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50739 15C6.50739 15.4142 6.84317 15.75 7.25739 15.75C7.6716 15.75 8.00739 15.4142 8.00739 15L6.50739 15ZM8.00739 15L8.00739 5L6.50739 5L6.50739 15L8.00739 15Z",
    fill: "#77787A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.75735L7.25736 4.51471",
    stroke: "#77787A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01477 8.75735L7.25741 4.51471",
    stroke: "#77787A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1H1.5",
    stroke: "#77787A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgReturnTop;